import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { API_URL } from '../config/api'

const BACKEND_API_URL = API_URL

interface Company {
  id: string
  name: string
  website: string
  industry?: string
  createdAt?: string
}

interface CompaniesState {
  companies: Company[]
  loading: boolean
  error: string | null
}

const initialState: CompaniesState = {
  companies: [],
  loading: false,
  error: null
}

export const fetchCompanies = createAsyncThunk(
  'companies/fetchCompanies',
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token')
      const response = await axios.get(`${BACKEND_API_URL}/company/listcompanies`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      const companies = Array.isArray(response.data) ? response.data : []
      return companies.map((company: any) => ({
        id: company.id ?? company.Id ?? company._id ?? '',
        name: company.name ?? company.Name ?? '',
        website: company.website ?? company.Website ?? '',
        industry: company.industry ?? company.sector ?? company.Sector ?? '',
        createdAt: company.createdAt ?? company.CreatedAt
      }))
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message)
    }
  }
)

const companiesSlice = createSlice({
  name: 'companies',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanies.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        state.loading = false
        state.companies = action.payload
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  }
})

export default companiesSlice.reducer
